








































import { defineComponent, toRefs, PropType, computed, onMounted, ref } from '@vue/composition-api';
import {
  AcoFormData,
  AdgroupFormData,
  CampaignFormData,
  CreativeConfig,
  FullNormalFormData,
  NormalCreative,
  VerticalCreativeStrategy,
} from '@tt4b/ttam-enums';
import SmartCreative from './index';
import InteractiveAddon from '../interactive-add-on/index';
import InstantPage from '../instant-page/index';
import DynamicFormat from '@tt4b/ttam-assets/src/images/Dynamic_Format_Small.gif';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-smart-creative-compose';
export default defineComponent({
  name,
  components: {
    TtamSmartCreativeSwitch: SmartCreative.TtamSmartCreativeSwitch,
    TtamSmartCreativeErrorTip: SmartCreative.TtamSmartCreativeErrorTip,
    ALink,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<AcoFormData & FullNormalFormData>,
      default: () => ({}),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    normalCreative: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: 'create',
    },
  },
  setup(props, { emit }) {
    const { creativeData, creativeConfig, campaignData } = toRefs(props);

    const verticalCreativeStrategy = computed({
      get() {
        return creativeData.value.verticalCreativeStrategy ?? VerticalCreativeStrategy.UNSET;
      },
      set(val) {
        emit('change', {
          verticalCreativeStrategy: val,
        });
      },
    });

    const { disabled } = SmartCreative.usePropsDisabled({
      creativeConfig,
    });

    const { visible: showCardError } = InteractiveAddon.usePropsErrorTipVisible({
      creativeData,
    });

    const { visible: showPageError } = InstantPage.usePropsErrorTipVisible({
      campaignData,
      creativeData,
    });

    const createCard = () => {
      emit('create-card');
    };

    const createPage = () => {
      emit('create-page');
    };

    onMounted(() => {
      // 预加载一下那个gif
      new Image().src = DynamicFormat;
    });

    return {
      name,
      verticalCreativeStrategy,
      disabled,
      showCardError,
      showPageError,
      createCard,
      createPage,
      DynamicFormat,
    };
  },
});
